import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import backgroundImage from "./images/bg-roof-panels-gradient.png";
// import Rating from "@mui/material/Rating";
// import Skeleton from "@mui/material/Skeleton"; // skeleton temporarily disabled
// import Collapse from "@mui/material/Collapse"; // collapse temporarily disabled
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';

import ReviewBadge from "./ReviewBadge";
import "./style.css";

export function getBulletIcons(profileDetails) {
    console.log("Profile Details in getBulletIcons:", profileDetails);
    const bulletIcons = {
        yearEstablished: {
            icon: 'fa-calendar',
            text: 'Established in ' + profileDetails.yearEstablished
        },
        panelWarranty: {
            icon: 'fa-bolt',
            text: profileDetails.panelWarranty + ' Solar Panel Warranty'
        },
        performanceWarranty: {
            icon: 'fa-chart-line',
            text: profileDetails.performanceWarranty + ' Performance Warranty'
        },
        insulationWarranty: {
            icon: 'fa-bolt',
            text: profileDetails.insulationWarranty + ' Insulation Warranty'
        },
        evChargerWarranty: {
            icon: 'fa-bolt',
            text: profileDetails.evChargerWarranty + ' EV Charger Warranty'
        },
        heatPumpWarranty: {
            icon: 'fa-bolt',
            text: profileDetails.heatPumpWarranty + ' Heat Pump Warranty'
        },
        workmanshipWarranty: {
            icon: 'fa-wrench',
            text: profileDetails.workmanshipWarranty + ' Workmanship Warranty'
        },
        totalStaff: {
            icon: 'fa-users',
            text: profileDetails.totalStaff + ' Staff'
        },
        annualInstallations: {
            icon: 'fa-check',
            text: profileDetails.annualInstallations + ' Annual Installations'
        },
        publicLiabilityInsurance: {
            icon: 'fa-calculator',
            text: 'Public Liability Insurance'
        },
        professionalIndemnityInsurance: {
            icon: 'fa-file-alt',
            text: 'Professional Indemnity Insurance'
        },
        dedicatedSupport: {
            icon: 'fa-phone',
            text: 'Dedicated Support Team'
        },
        seaiApproved: {
            icon: 'fa-thumbs-up',
            text: 'SEAI Approved Installer'
        }
    };
    return bulletIcons;
}

// Resolves the selected bullets into an ordered list of { key, icon, text } items
// ready to render. Each product warranty is its own selectable bullet drawn from
// the matching Public Profile field; bullets whose text would render as
// "undefined ..." (missing underlying value) are skipped.
export function resolveBullets(profileDetails, technology) {
    const selection = profileDetails.bullets || {};
    const icons = getBulletIcons(profileDetails);
    const items = [];

    Object.keys(icons).forEach(key => {
        if (!selection[key]) return;
        if (String(icons[key].text).includes('undefined')) return;
        items.push({ key, icon: icons[key].icon, text: icons[key].text });
    });

    return items;
}

const ProviderSummary = ({ profileDetails, technology, reviewsUrl, reviewsRating, reviewsTotal, name, url, openingHours, profileVerified }) => {
    const bulletItems = resolveBullets(profileDetails, technology);
    // const [openHoursOpen, setOpenHoursOpen] = useState(false); // opening hours disabled
    // const [showReviewsSkeleton, setShowReviewsSkeleton] = useState(true); // skeleton disabled
    // const [showPlaceSection, setShowPlaceSection] = useState(!!profileDetails.placeId); // entire section disabled

    // Decide if we have reviews data
    // const hasReviewsData = (
    //     typeof reviewsUrl !== 'undefined' &&
    //     typeof reviewsRating !== 'undefined' &&
    //     typeof reviewsTotal !== 'undefined'
    // );

    // If reviews arrive, stop showing skeleton immediately. If they never arrive
    // (e.g. fetch failed), hide skeleton after a timeout so it doesn't persist forever.
    // Skeleton timing effect disabled
    // useEffect(() => { ... }, [hasReviewsData, showReviewsSkeleton]);

    // Opening hours arrival detection
    // const hasOpeningHoursData = (
    //     typeof openingHours !== 'undefined' &&
    //     typeof openingHours.weekday_text !== 'undefined'
    // );

    // Manage hiding the entire place section (reviews + opening hours) if neither reviews nor opening hours data arrives.
    // Visibility timing effect disabled
    // useEffect(() => { ... }, [showPlaceSection, hasReviewsData, hasOpeningHoursData]);
    //console.log("Reviews Total:", reviewsTotal);

    // Responsive paddingLeft for desktop/mobile
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
    const responsivePaddingLeft = isMobile ? 16 : 224;
    // Desktop only: left offset for name
    const nameLeft = 224;
    const nameWidth = `calc(100% - 224px)`;

    return (
        <div style={{ width: '100%' }}>
            {/* ============================== MOBILE LAYOUT ============================== */}
            {isMobile && (
                <>
                    <div style={{
                        position: 'relative',
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                        padding: '28px 20px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                    }}>
                        {profileDetails.logo && (
                            <img
                                src={profileDetails.logo + '?v=' + Date.now()}
                                alt="Logo"
                                style={{
                                    width: 96,
                                    height: 96,
                                    objectFit: 'contain',
                                    borderRadius: '50%',
                                    backgroundColor: '#fff',
                                    border: '1px solid #ABDC8B',
                                    marginBottom: 14,
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                                }}
                            />
                        )}
                        <h1 style={{
                            color: '#023a51',
                            fontSize: '22px',
                            fontWeight: 700,
                            margin: 0,
                            fontFamily: 'Manrope, Arial, sans-serif',
                            lineHeight: 1.25,
                            wordBreak: 'break-word',
                            maxWidth: '100%',
                        }}>
                            {name}
                        </h1>
                        {profileVerified === 'Verified' && (
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                marginTop: 10,
                            }}>
                                <img
                                    src="https://energyefficiency.ie/wp-content/uploads/2025/02/verified.png"
                                    alt="Verified"
                                    style={{ width: 18, height: 18, marginRight: 6 }}
                                />
                                <span style={{ fontSize: 14, color: '#229626', fontWeight: 600, lineHeight: 1 }}>
                                    Verified Installer
                                </span>
                            </div>
                        )}
                        {profileDetails.reviewsEnabled === true && profileDetails.reviewsRating && (
                            <div style={{ marginTop: 16 }}>
                                <ReviewBadge
                                    rating={profileDetails.reviewsRating}
                                    platform={profileDetails.reviewsPlatform}
                                    reviewsCount={profileDetails.reviewsCount}
                                    isMobile={isMobile}
                                />
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* ============================== DESKTOP LAYOUT (unchanged) ============================== */}
            {!isMobile && (
                <Grid container spacing={2} alignItems="flex-start" style={{
                    position: "relative",
                    paddingTop: 60,
                    paddingBottom: 60,
                    paddingLeft: responsivePaddingLeft,
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right center',
                    minHeight: 86,
                    borderTopLeftRadius: 11,
                    borderTopRightRadius: 11,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0
                }}>
                    {profileDetails.reviewsEnabled === true && profileDetails.reviewsRating && (
                        <ReviewBadge
                            rating={profileDetails.reviewsRating}
                            platform={profileDetails.reviewsPlatform}
                            reviewsCount={profileDetails.reviewsCount}
                            isMobile={isMobile}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: 40,
                                transform: 'translateY(-50%)'
                            }}
                        />
                    )}
                    {profileDetails.logo && (
                        <Grid container justifyContent="left" size={2} style={{ marginBottom: -20, position: "absolute", left: 30 }}>
                            <img
                                src={profileDetails.logo + '?v=' + Date.now()}
                                alt="Logo"
                                style={{
                                    width: 150,
                                    height: 150,
                                    aspectRatio: "1/1",
                                    objectFit: "contain",
                                    borderRadius: "50%",
                                    backgroundColor: "#fff",
                                    border: "1px solid #ABDC8B",
                                    maxWidth: "none"
                                }}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} style={{
                        position: "absolute",
                        top: "50%",
                        left: nameLeft,
                        transform: "translateY(-50%)",
                        zIndex: 20,
                        width: nameWidth
                    }}>
                        <Grid container direction="column" alignItems="flex-start" style={{ padding: 20, paddingRight: 40 }}>
                            <Grid item>
                                <h1 style={{ color: "#023a51", fontSize: "35px", fontWeight: "700", margin: 0, font: "Manrope" }}>
                                    {name}
                                </h1>
                            </Grid>
                            {profileVerified === 'Verified' && (
                                <Grid item style={{ marginTop: 8 }}>
                                    <Grid container alignItems="center" style={{ flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src="https://energyefficiency.ie/wp-content/uploads/2025/02/verified.png"
                                                alt="Verified"
                                                style={{ width: 20, height: 20, marginRight: 8, display: 'block' }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <span style={{ fontSize: '18px', color: '#229626', lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                                                Verified Installer
                                            </span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            )}
            {/* Bottom Section with bullet points */}
            {bulletItems.length === 0 && <div style={{ paddingBottom: 10 }} />}
            {bulletItems.length > 0 && (
                <Grid
                    container
                    direction="column"
                    spacing={1}
                    style={{
                        marginTop: 20,
                        paddingLeft: isMobile ? 30 : responsivePaddingLeft,
                        paddingRight: isMobile ? 30 : 0,
                    }}
                >
                    {/* Bullet Points */}
                    <Grid item>
                        <Grid container spacing={2} style={{ paddingTop: 15, paddingBottom: 30 }}>
                            {(isMobile ? bulletItems.slice(0, 4) : bulletItems).map(item => (
                                <Grid key={item.key} size={isMobile ? 12 : 6} style={{ display: "flex", alignItems: "center" }}>
                                    <i className={`fa ${item.icon}`} 
                                       style={{ 
                                           marginRight: 15, 
                                           display: "flex", 
                                           alignItems: "center", 
                                           justifyContent: "center", 
                                           minWidth: 30, 
                                           color: "#229626"
                                       }}>
                                    </i>
                                    <span>{item.text}</span>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default ProviderSummary;